import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function refundInvoice(invoiceNo: string) {
  const res = await fetchOrchidAPI(`/api/invoicing/refund/${invoiceNo}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    throw new Error(
      `failed to refund invoice: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
